// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22 22H2V2H22V22ZM6 18H10V14H6V18ZM14 18H18V14H14V18ZM10 14H14V10H10V14ZM6 6V10H10V6H6ZM14 10H18V6H14V10Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-mosaic-filled')
export default class MosaicFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'mosaic-filled',
    }
  }
}
